import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { isEmpty, pick } from 'lodash';

import ConfirmDeleteModal from './Components/ConfirmDeleteModal';
import SegmentForm from '../../../components/AudienceSegment/SegmentForm';
import { formatFilters } from '../../../utils/segments';

export const Segments = ({
  segments,
  onSave,
  updateFilterOptions,
  deleteSegment,
  config,
  name,
  id
}) => {
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [editSegment, setEditSegment] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [searchText, setSearchText] = useState('');

  useEffect(() => {}, [config]);

  const findSegment = value => {
    return value ? segments.filter(s => s.uuid === value)[0] : null;
  };

  const onconfirmDeleteSegment = e => {
    e.preventDefault();
    setSelected(e.currentTarget.value);
    setShowConfirmDeleteModal(true);
  };
  const handleCloseModal = () => {
    setShowConfirmDeleteModal(false);
  };

  const handleConfirmDelete = () => {
    deleteSegment(selected);
    handleCloseModal();
  };

  const onChangeSearch = e => setSearchText(e.target.value.toLowerCase());

  const onEditPress = e => {
    e.preventDefault();
    setSelected(e.currentTarget.value);
    setEditSegment(true);
    setOpenModal(true);
  };

  const onCloseEdit = () => {
    setOpenModal(false);
    setEditSegment(false);
    setSelected(null);
  };

  const createSegment = () => {
    setOpenModal(true);
  };

  const formatFiltersForForm = () => {
    const filters = formatFilters(config);
    const segment = findSegment(selected);
    if (segment && segment.filters) {
      const activeFilters = JSON.parse(segment.filters);
      return filters.map(filter => {
        const af = activeFilters.find(f => f.id === filter.id);
        if (af) {
          const { value } = af;
          return { ...filter, value };
        }
        return filter;
      });
    }

    return filters;
  };

  const formatName = () => {
    const segment = findSegment(selected);
    if (segment && segment.name) {
      return segment.name;
    }

    return '';
  };

  const handleSave = async (segmentId, segmentName, filts) => {
    const activeFilters = filts
      .filter(({ value }) => !isEmpty(value))
      .map(f =>
        pick(f, [
          'value',
          'id',
          'isAsync',
          'isMulti',
          'label',
          'title',
          'value'
        ])
      );

    const response = await onSave(
      segmentId,
      segmentName,
      JSON.stringify(activeFilters)
    );

    if (!response) {
      return null;
    }

    onCloseEdit();
  };

  return (
    <div className="user-profile__segments-wrapper">
      <ConfirmDeleteModal
        isOpen={showConfirmDeleteModal}
        onClose={handleCloseModal}
        onDelete={handleConfirmDelete}
        messageBody="Are you sure you want to delete this segment? You cannot undo this action."
      />
      <Modal
        className="tvt-audience-segment"
        show={openModal}
        onHide={onCloseEdit}
        backdrop
      >
        <SegmentForm
          name={editSegment ? formatName() : name}
          id={editSegment ? selected : id}
          filters={formatFiltersForForm()}
          handleClose={onCloseEdit}
          onUpdateFilterOptions={updateFilterOptions}
          handleSave={handleSave}
          loading={false}
        />
      </Modal>
      <div className="user-profile__segments-header">
        <div className="user-profile__segments-header-search">
          <FontAwesomeIcon className="search-icon" icon="search" size="1x" />
          <input
            onChange={onChangeSearch}
            placeholder="Search by Segment Name..."
          />
        </div>
        <button onClick={createSegment}>Create a new segment</button>
      </div>
      <div className="user-profile__segments-list">
        {segments
          .filter(s => s.name.toLowerCase().includes(searchText))
          .map(s => (
            <div key={s.uuid} className="user-profile__segments-list-item">
              <div className="user-profile__segments-list-item-name">
                {s.name}
              </div>
              <button
                value={s.uuid}
                onClick={onEditPress}
                className="user-profile__segments-list-item-edit"
              >
                <FontAwesomeIcon icon="pencil-alt" size="1x" />
              </button>
              <button
                value={s.uuid}
                onClick={onconfirmDeleteSegment}
                className="user-profile__segments-list-item-delete"
              >
                <FontAwesomeIcon icon="trash-alt" size="1x" />
              </button>
            </div>
          ))}
      </div>
    </div>
  );
};

Segments.propTypes = {
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      dateCreated: PropTypes.number,
      dateModified: PropTypes.number,
      filters: PropTypes.string,
      label: PropTypes.string,
      name: PropTypes.string,
      userId: PropTypes.string,
      uuid: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  onSave: PropTypes.func.isRequired,
  updateFilterOptions: PropTypes.func.isRequired,
  deleteSegment: PropTypes.func.isRequired,
  config: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string
};

Segments.defaultProps = {
  id: null
};

export default Segments;
